import React, { useState, useEffect } from "react";
import "./ProfileTwo.scss";
import { HiEnvelope, HiPhone } from "react-icons/hi2";
import { projectStorage } from "../../firebase-config/config";
import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
import { Link } from "react-router-dom";
import {
  HiShoppingCart,
  HiHeart,
  HiClipboardList,
  HiLocationMarker,
  HiChevronRight,
  HiUsers,
  HiCube,
  HiTemplate,
  HiChartBar,
  HiColorSwatch,
  HiChat,
  HiKey,
  HiCreditCard,
  HiDocumentText,
  HiBell,
  HiShieldCheck,
  HiClock,
  HiHome,
  HiOutlineXCircle,
  HiInformationCircle,
  HiOutlineReceiptRefund,
  HiPhone as HiPhoneAlt,
  HiQuestionMarkCircle,
  HiShieldExclamation,
  HiLogout,
  HiTicket,
} from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import Popup from "../Popup";
import { useLogout } from "../../firebase-files/hooks/useLogout";
import DarkModeToggle from "react-dark-mode-toggle";

const ProfileTwo = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { document: dbTemplatesPaletteDocuments } = useDocument(
    "settings",
    "themePalette"
  );
  const { document: organisationDetails } = useDocument(
    "settings",
    "organisation"
  );
  const { updateDocument: updateMenuDocument } = useFirestore("settings");
  const { document: dynamicNavMenuDoc, error: dynamicNavMenuDocError } =
    useDocument("settings", "EditNavbarMenus");

  const { document: dbAppTypeDocuments } = useDocument("settings", "AppType");

  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState("");
  const { updateDocument } = useFirestore("users");
  const { document: appTypeDoc } = useDocument("settings", "AppType");
  const { document: pageControlDoc } = useDocument("settings", "pagesControl");

  // edit user details
  // change user details
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(true);
  const [userDetails, setUserDetails] = useState({
    fullName: "",
    city: "",
    email: "",
    phoneNumber: "",
  });

  // Add these states for logout functionality
  const [showPopupFlag, setShowPopupFlag] = useState(false);
  const [popupReturn, setPopupReturn] = useState(false);
  const { logout, isPending } = useLogout();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const userData = user;
        setUserData(userData);
        setSelectedRole(userData.role);
        console.log(userData);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (user) {
      fetchUserData();
    } else {
      setIsLoading(false);
    }
  }, [user]);

  // Add useEffect for handling logout confirmation
  useEffect(() => {
    if (popupReturn) {
      logout();
    }
  }, [popupReturn]);

  // Function to show logout confirmation popup
  const showLogoutPopup = (e) => {
    e.preventDefault();
    setShowPopupFlag(true);
    setPopupReturn(false);
  };

  // Function to handle role change
  const handleRoleChange = async (newRole) => {
    try {
      // Update in Firestore
      await updateDocument(userData.phoneNumber, {
        role: newRole,
      });

      // Update local state
      setUserData((prevData) => ({
        ...prevData,
        role: newRole,
      }));
      setSelectedRole(newRole);
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  const userInfo =
    user && user
      ? {
          name: userData.fullName,
          email: userData.email,
          mobile: userData.phoneNumber,
          role: userData.role,
          address: userData.addresses,
          createdAt: userData.createdAt,
          profileImage: null,
        }
      : "";

  const ecommerceMenus = [
    { icon: <HiHeart />, name: "Wishlist", link: "/wishlist" },
    { icon: <HiClipboardList />, name: "Orders", link: "/orders" },
    { icon: <HiLocationMarker />, name: "Address", link: "/address" },
    { icon: <HiBell />, name: "Notifications", link: "/notifications" },
  ];

  const adminMenus = [
    {
      icon: <HiUsers />,
      name: "User Management",
      description: "Manage user roles, permissions and access controls",
      link: "/all-users",
    },
    {
      icon: <HiCube />,
      name: "Product Management",
      description: "Add, edit and manage product inventory",
      link: "/admin-panel",
    },
    {
      icon: <HiTemplate />,
      name: "Category Management",
      description: "Organize and structure product categories",
      link: "/add-categories",
    },
    {
      icon: <HiColorSwatch />,
      name: "Site Management",
      description: "Manage website Themes and Styles",
      link: "/sitesettings",
    },
    {
      icon: <HiChat />,
      name: "Enquiry Management",
      description: "Handle customer inquiries and replies",
      link: "/enquries-list",
    },
  ];

  const customerMenus = [
    {
      icon: <HiKey />,
      name: "Account Settings",
      description: "Update your profile and personal information",
    },
    {
      icon: <HiCreditCard />,
      name: "Payment Methods",
      description: "Manage your saved payment options",
    },
    {
      icon: <HiDocumentText />,
      name: "Order History",
      description: "View and track your past orders",
    },
    {
      icon: <HiBell />,
      name: "Notifications",
      description: "Customize your notification preferences",
    },
    {
      icon: <HiShieldCheck />,
      name: "Privacy Settings",
      description: "Manage your privacy and security options",
    },
    {
      icon: <HiClock />,
      name: "Recent Activity",
      description: "View your recent account activities",
    },
  ];

  const defaultMenus = [
    {
      icon: <HiHome />,
      name: "Home",
      description: "Return to homepage dashboard",
      link: "/",
    },
    {
      icon: <HiInformationCircle />,
      name: "About",
      description: "Learn more about our company and mission",
      link: "/aboutus",
    },
    {
      icon: <HiPhoneAlt />,
      name: "Contact",
      description: "Get in touch with our support team",
      link: "/contact",
    },
    {
      icon: <HiQuestionMarkCircle />,
      name: "FAQ",
      description: "Find answers to common questions",
      link: "/faq",
    },
    {
      icon: <HiShieldExclamation />,
      name: "Privacy Policy",
      description: "Read our privacy policy and data usage",
      link: "/privacy-policy",
    },
    {
      icon: <HiDocumentText />,
      name: "Terms & Conditions",
      description: "View our terms of service",
      link: "/term-condition",
    },
    {
      icon: <HiOutlineXCircle />,
      name: "Cancellation Policy",
      description: "View our Cancellation Policy of service",
      link: "/page/NMD77NC0RnhYL7SgfuQo",
    },
    {
      icon: <HiOutlineReceiptRefund />,
      name: "Refund Policy",
      description: "View our Refund Policy of service",
      link: "/page/NMD77NC0RnhYL7SgfuQo",
    },
  ];

  // START USER DETAILS EDIT CODE
  useEffect(() => {
    if (user) {
      setUserDetails({
        fullName: user.fullName,
        address: user.address,
        city: user.city,
        email: user.email,
        phoneNumber: user.phoneNumber,
      });
    }
  }, [user]);

  const handleEditClick = () => {
    setShowEditPopup(true);
    setConfirmButtonDisabled(true); // Disable the confirm button initially
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    setConfirmButtonDisabled(false); // Enable the confirm button when any input changes
  };

  const handleCancelClick = () => {
    setShowEditPopup(false);
  };

  // Confirm update
  const handleConfirmClick = async () => {
    try {
      await updateDocument(user.phoneNumber, userDetails);
      setShowEditPopup(false);
    } catch (error) {
      console.error("Error updating user details:", error);
    }
  };
  // END USER DETAILS EDIT CODE

  // START CHANGE IMG CODE START
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState();
  const [selectedDummyImage, setSelectedDummyImage] = useState(null);
  const [imgUploading, setImgUploading] = useState(false);
  const [dummyImages, setDummyImages] = useState([
    "/assets/img/profile-option-1.png",
    "/assets/img/profile-option-2.png",
    "/assets/img/profile-option-3.png",
    "/assets/img/profile-option-4.jfif",
    "/assets/img/profile-option-5.jpg",
    "/assets/img/profile-option-6.jfif",
  ]);

  const defaultImageUrl =
    "https://firebasestorage.googleapis.com/v0/b/propdial-dev-aa266.appspot.com/o/userThumbnails%2F1default.png?alt=media&token=38880453-e642-4fb7-950b-36d81d501fe2";
  const handleImageClick = () => {
    setShowImagePopup(true);
  };

  const handleRemoveImage = () => {
    setImagePreview(defaultImageUrl); // Set to default image URL
    setSelectedImage(null);
    setSelectedDummyImage(null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      setSelectedImage(file);
    }
  };

  const handleDummyImageClick = (imageUrl) => {
    setSelectedDummyImage(imageUrl);
    setImagePreview(imageUrl);
  };

  const handleCancelImgClick = () => {
    setShowImagePopup(false);
  };

  const handleConfirmImgClick = async () => {
    try {
      if (selectedImage) {
        setImgUploading(true); // Set loader on
        const uploadPath = `userThumbnails/${user.phoneNumber}/${selectedImage.name}`;
        const uploadTask = projectStorage.ref(uploadPath).put(selectedImage);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Handle progress
          },
          (error) => {
            console.error("Error uploading file:", error);
            setImgUploading(false); // Set loader off on error
          },
          async () => {
            const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
            await updateDocument(user.phoneNumber, { photoURL: downloadURL });
            setImagePreview(downloadURL);
            setSelectedImage(null);
            setImgUploading(false); // Set loader off
            setShowImagePopup(false);
          }
        );
      } else if (selectedDummyImage) {
        setImgUploading(true);
        await updateDocument(user.phoneNumber, {
          photoURL: selectedDummyImage,
        });
        setImagePreview(selectedDummyImage);
        setSelectedDummyImage(null);
        setImgUploading(false); // Set loader off
        setShowImagePopup(false);
      } else {
        setImgUploading(true);
        await updateDocument(user.phoneNumber, { photoURL: defaultImageUrl });
        setImagePreview(defaultImageUrl);
        setImgUploading(false); // Set loader off
        setShowImagePopup(false);
      }
    } catch (error) {
      console.error("Error updating image URL:", error);
      setImgUploading(false); // Set loader off on error
    }
  };
  // END CHANGE IMG CODE START

  //  START FETCH DYNAMIC MENUS FROM DB
  const handleVisibleInProfilePage = async (menuIndex, subMenuIndex = null) => {
    const updatedMenuDetails = [...dynamicNavMenuDoc.menuDetails];

    if (subMenuIndex === null) {
      // Toggle visibility for the main menu
      const currentVisibility =
        updatedMenuDetails[menuIndex]?.visibilityInProfilePage || false;
      updatedMenuDetails[menuIndex].visibilityInProfilePage =
        !currentVisibility;
    } else {
      // Toggle visibility for the submenu
      const currentVisibility =
        updatedMenuDetails[menuIndex]?.subMenu[subMenuIndex]
          ?.visibilityInProfilePage || false;
      updatedMenuDetails[menuIndex].subMenu[
        subMenuIndex
      ].visibilityInProfilePage = !currentVisibility;
    }

    try {
      // Update Firestore document
      await updateMenuDocument("EditNavbarMenus", {
        menuDetails: updatedMenuDetails,
      });
      console.log("Visibility updated successfully");
    } catch (error) {
      console.error("Error updating visibility:", error);
      alert("There was an error updating the visibility. Please try again.");
    }
  };
  //  END FETCH DYNAMIC MENUS FROM DB
  return (
    <>
      {/* Add Popup component */}
      <Popup
        showPopupFlag={showPopupFlag}
        setShowPopupFlag={setShowPopupFlag}
        setPopupReturn={setPopupReturn}
        msg={"Are you sure you want to logout?"}
      />

      <div className="profile-two">
        <div className="profile-two__container">
          {/* Left Column */}
          <div className="profile-two__left-column">
            {isLoading ? (
              <div className="profile-two__loading">
                <div className="profile-two__loading-spinner"></div>
                <p>Loading profile...</p>
              </div>
            ) : user && user ? (
              <section className="profile-two__user-info">
                <div className="profile-two__cover-container">
                  {user && user && (
                    <span
                      className="material-symbols-outlined business-three-profile-edit-icon"
                      onClick={handleEditClick}
                    >
                      edit
                    </span>
                  )}
                  {/* <button
                    className="profile-two__see-more-btn"
                    onClick={() =>
                      navigate(`/user-detail/${userData.phoneNumber}`)
                    }
                  >
                    See More
                    <HiChevronRight className="profile-two__see-more-icon" />
                  </button> */}
                </div>
                <div className="profile-two__user-info-container">
                  <div className="profile-two__image-wrapper">
                    <div className="profile-two__image-container">
                      <div style={{ position: "relative" }}>
                        <img
                          src={user && user.photoURL}
                          alt={`${userData.fullName}'s profile`}
                          className="profile-two__user-image"
                        />{" "}
                        {dbTemplatesPaletteDocuments &&
                        dbTemplatesPaletteDocuments.activeThemePalette ===
                          "defaultThemePalette" ? (
                          <div className="business-three-profile-img-camera-occation-img"></div>
                        ) : dbTemplatesPaletteDocuments &&
                          dbTemplatesPaletteDocuments.activeThemePalette ===
                            "diwaliThemePalette" ? (
                          <img
                            src="/assets/img/themes/diwali-rocket.gif"
                            className="business-three-profile-img-camera-occation-img"
                            alt="Diwali Theme"
                          />
                        ) : dbTemplatesPaletteDocuments &&
                          dbTemplatesPaletteDocuments.activeThemePalette ===
                            "holiThemePalette" ? (
                          <img
                            src="/assets/img/themes/holi-rangoli.webp"
                            className="business-three-profile-img-holi-occation-img"
                            alt="Holi Theme"
                          />
                        ) : dbTemplatesPaletteDocuments &&
                          dbTemplatesPaletteDocuments.activeThemePalette ===
                            "womenDayThemePalette" ? (
                          user && user.gender && user.gender === "female" ? (
                            <img
                              src="/assets/img/themes/women-day-transprent-flower.png"
                              alt="Women's Day Flower"
                              className="business-three-profile-img-holi-occation-img"
                            />
                          ) : (
                            <div className="business-three-profile-img-camera-occation-img"></div>
                          )
                        ) : null}
                      </div>
                      <span
                        className="material-symbols-outlined business-three-profile-camera-icon"
                        onClick={handleImageClick}
                      >
                        photo_camera
                      </span>
                    </div>
                  </div>
                  <div className="profile-two__details">
                    <h2 className="profile-two__name">{userData.fullName}</h2>
                    <div className="profile-two__badges">
                      {/* Show role switcher only for admin or superAdmin */}
                      {userData.roles &&
                      (userData.roles.includes("admin") ||
                        userData.roles.includes("superAdmin")) ? (
                        userData.roles.map((role, index) => (
                          <div
                            key={index}
                            className={`profile-two__badge ${
                              role === userData.role
                                ? "profile-two__badge--active"
                                : ""
                            }`}
                            onClick={() => handleRoleChange(role)}
                            style={{ cursor: "pointer" }}
                          >
                            {role}
                          </div>
                        ))
                      ) : (
                        <>{/* Do nothing for customer */}</>
                      )}
                    </div>

                    <div className="profile-two__info-section">
                      <div className="profile-two__info-group">
                        <div className="profile-two__contact-info">
                          <div className="profile-two__info-item">
                            <HiPhone className="profile-two__icon" />

                            <span>
                              {String(userData.phoneNumber).replace(
                                /^91(\d{5})(\d{5})$/,
                                "91-$1-$2"
                              )}
                            </span>
                          </div>
                          <div className="profile-two__info-item">
                            <HiEnvelope className="profile-two__icon" />
                            <span>{userData.email}</span>
                          </div>
                        </div>
                      </div>

                      {/* {userData.addresses && userData.addresses.length > 0 && (
                        <div className="profile-two__info-group">
                          <Link
                            to="/address"
                            className="profile-two__info-item profile-two__info-item--address"
                          >
                            {" "}
                            <HiLocationMarker className="profile-two__icon" />
                            <span>
                              {userData.addresses[0].houseNumber},
                              {userData.addresses[0].streetLineOne},
                              {userData.addresses[0].streetLineTwo},
                              {userData.addresses[0].city},
                              {userData.addresses[0].state},
                              {userData.addresses[0].country},
                              {userData.addresses[0].pincode}
                            </span>
                          </Link>
                        </div>
                      )} */}
                      {pageControlDoc?.address === true &&
                        userData.addresses &&
                        userData.addresses.length > 0 && (
                          <div className="profile-two__info-group">
                            <Link
                              to="/address"
                              className="profile-two__info-item profile-two__info-item--address"
                            >
                              <HiLocationMarker className="profile-two__icon" />
                              <span>
                                {userData.addresses[0].houseNumber},
                                {userData.addresses[0].streetLineOne},
                                {userData.addresses[0].streetLineTwo},
                                {userData.addresses[0].city},
                                {userData.addresses[0].state},
                                {userData.addresses[0].country},
                                {userData.addresses[0].pincode}
                              </span>
                            </Link>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <div className="profile-two__login-container">
                <h2 className="profile-two__login-title">
                  Please Login to Continue
                </h2>
                <div className="profile-two__login-icon-container">
                  <HiShieldCheck className="profile-two__login-icon" />
                </div>
                <button
                  className="profile-two__login-button"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Login
                </button>
              </div>
            )}
          </div>

          {/* Right Column */}
          <div className="profile-two__right-column">
            {/*START FOR CUSTOMERS */}
            {user && user.role === "customer" && (
              <section className="profile-two__ecommerce-section">
                <h3 className="profile-two__section-title">Quick Actions</h3>
                <div className="profile-two__menu-grid">
                  {pageControlDoc?.cart === true && (
                    <div
                      className="profile-two__menu-tile"
                      onClick={() => navigate("/cart")}
                    >
                      <div className="profile-two__menu-icon">
                        <HiShoppingCart />
                      </div>
                      <span className="profile-two__menu-name">Cart</span>
                    </div>
                  )}
                  {/* {ecommerceMenus.map((menu, index) => (
                    <div
                      key={index}
                      className="profile-two__menu-tile"
                      onClick={() => navigate(menu.link)}
                    >
                      <div className="profile-two__menu-icon">{menu.icon}</div>
                      <span className="profile-two__menu-name">
                        {menu.name}
                      </span>
                    </div>
                  ))} */}
                  {ecommerceMenus.map(
                    (menu, index) =>
                      (menu.name === "Address"
                        ? pageControlDoc?.address === true
                        : true) && (
                        <div
                          key={index}
                          className="profile-two__menu-tile"
                          onClick={() => navigate(menu.link)}
                        >
                          <div className="profile-two__menu-icon">
                            {menu.icon}
                          </div>
                          <span className="profile-two__menu-name">
                            {menu.name}
                          </span>
                        </div>
                      )
                  )}
                </div>
              </section>
            )}
            {/*END FOR CUSTOMERS */}

            {user && (user.role === "admin" || user.role === "superAdmin") && (
              <>
                <section className="profile-two__admin-quick-actions">
                  <div className="profile-two__admin-quick-actions-container">
                    {appTypeDoc && appTypeDoc.apptype !== "lite" && (
                      <div
                        className="profile-two__admin-quick-actions-item"
                        onClick={() => navigate("/admin-panel")}
                      >
                        <HiChartBar className="profile-two__admin-quick-actions-item-icon" />
                        <span>Dashboard</span>
                      </div>
                    )}
                    <div
                      className="profile-two__admin-quick-actions-item"
                      onClick={() => navigate("/all-users")}
                    >
                      <HiUsers className="profile-two__admin-quick-actions-item-icon" />
                      <span>User Management</span>
                    </div>
                    <div
                      className="profile-two__admin-quick-actions-item"
                      onClick={() => navigate("/notifications")}
                    >
                      <HiBell className="profile-two__admin-quick-actions-item-icon" />
                      <span>Notifications</span>
                    </div>
                    <div
                      className="profile-two__admin-quick-actions-item"
                      onClick={() => navigate("/admin-panel")}
                    >
                      <HiTicket className="profile-two__admin-quick-actions-item-icon" />
                      <span>Support Tickets</span>
                    </div>
                  </div>
                </section>

                <section className="profile-two__admin-section">
                  <h3 className="profile-two__section-title">Admin Controls</h3>
                  <div className="profile-two__admin-menu-grid">
                    {/* {appTypeDoc && appTypeDoc.apptype !== "lite" && (
                      <div
                       
                        className="profile-two__admin-menu-item"
                        onClick={() => navigate("/admin-panel")}
                      >
                        <div className="profile-two__admin-menu-content">
                          <div className="profile-two__admin-menu-icon">
                          <HiChartBar />
                          </div>
                          <div className="profile-two__admin-menu-text">
                            <h4 className="profile-two__admin-menu-name">
                            Analytics Dashboard
                            </h4>
                            <p className="profile-two__admin-menu-description">
                            View detailed sales and performance metrics
                            </p>
                          </div>
                          <div className="profile-two__admin-menu-arrow">
                            <HiChevronRight />
                          </div>
                        </div>
                      </div>)} */}

                    {user &&
                      appTypeDoc &&
                      ((appTypeDoc.apptype === "lite" &&
                        user.role === "superAdmin") ||
                        (appTypeDoc.apptype !== "lite" &&
                          (user.role === "admin" ||
                            user.role === "superAdmin"))) && (
                        <div
                          className="profile-two__admin-menu-item"
                          onClick={() => navigate("/admin-panel")}
                        >
                          <div className="profile-two__admin-menu-content">
                            <div className="profile-two__admin-menu-icon">
                              <HiChartBar />
                            </div>
                            <div className="profile-two__admin-menu-text">
                              <h4 className="profile-two__admin-menu-name">
                                Analytics Dashboard
                              </h4>
                              <p className="profile-two__admin-menu-description">
                                View detailed sales and performance metrics
                              </p>
                            </div>
                            <div className="profile-two__admin-menu-arrow">
                              <HiChevronRight />
                            </div>
                          </div>
                        </div>
                      )}

                    {adminMenus.map((menu, index) => (
                      <div
                        key={index}
                        className="profile-two__admin-menu-item"
                        onClick={() => navigate(menu.link)}
                      >
                        <div className="profile-two__admin-menu-content">
                          <div className="profile-two__admin-menu-icon">
                            {menu.icon}
                          </div>
                          <div className="profile-two__admin-menu-text">
                            <h4 className="profile-two__admin-menu-name">
                              {menu.name}
                            </h4>
                            <p className="profile-two__admin-menu-description">
                              {menu.description}
                            </p>
                          </div>
                          <div className="profile-two__admin-menu-arrow">
                            <HiChevronRight />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </>
            )}

            {/* {user && user.role === "customer" && (
              <section className="profile-two__customer-section">
                <h3 className="profile-two__section-title">
                  Customer Controls
                </h3>
                <div className="profile-two__admin-menu-grid">
                  {customerMenus.map((menu, index) => (
                    <div key={index} className="profile-two__admin-menu-item">
                      <div className="profile-two__admin-menu-content">
                        <div className="profile-two__admin-menu-icon">
                          {menu.icon}
                        </div>
                        <div className="profile-two__admin-menu-text">
                          <h4 className="profile-two__admin-menu-name">
                            {menu.name}
                          </h4>
                          <p className="profile-two__admin-menu-description">
                            {menu.description}
                          </p>
                        </div>
                        <div className="profile-two__admin-menu-arrow">
                          <HiChevronRight />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )} */}

            <section className="profile-two__default-section">
              <h3 className="profile-two__section-title">Quick Links</h3>
              <div className="profile-two__admin-menu-grid">
                {defaultMenus.map((menu, index) => (
                  <div
                    key={index}
                    className="profile-two__admin-menu-item"
                    onClick={() => navigate(menu.link)}
                  >
                    <div className="profile-two__admin-menu-content">
                      <div className="profile-two__admin-menu-icon">
                        {menu.icon}
                      </div>
                      <div className="profile-two__admin-menu-text">
                        <h4 className="profile-two__admin-menu-name">
                          {menu.name}
                        </h4>
                        <p className="profile-two__admin-menu-description">
                          {menu.description}
                        </p>
                      </div>
                      <div className="profile-two__admin-menu-arrow">
                        <HiChevronRight />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* START CODE FOR DEVELOPER */}
            {user && user.role === "developer" && (
              <section className="profile-two__default-section">
                <h3 className="profile-two__section-title">Developers Menus</h3>
                <div className="profile-two__admin-menu-grid">
                  <div className="profile-two__admin-menu-item">
                    <Link
                      to="https://co-verify-1029517600597.us-west1.run.app/"
                      target="_blank"
                      className="profile-two__admin-menu-content"
                    >
                      <div className="profile-two__admin-menu-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="currentColor"
                        >
                          <path d="m384-336 56-57-87-87 87-87-56-57-144 144 144 144Zm192 0 144-144-144-144-56 57 87 87-87 87 56 57ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
                        </svg>
                      </div>
                      <div className="profile-two__admin-menu-text">
                        <h4 className="profile-two__admin-menu-name">
                          AI Co-Verify
                        </h4>
                        <p className="profile-two__admin-menu-description">
                          Verify your code with AI
                        </p>
                      </div>
                      <div className="profile-two__admin-menu-arrow">
                        <HiChevronRight />
                      </div>
                    </Link>
                  </div>
                </div>
              </section>
            )}
            {/* END CODE FOR DEVELOPERS */}
            {/* DYNAMIC MENUS START */}
            <>
              <div className="profile-two__default-section">
                <h3 className="profile-two__section-title">More Pages</h3>
                <div className="profile-two__admin-menu-grid">
                  {dynamicNavMenuDoc &&
                    dynamicNavMenuDoc.menuDetails &&
                    dynamicNavMenuDoc.menuDetails.map((menu, index) => {
                      // Skip menu if menuStatus is inactive
                      if (menu.menuStatus === "inactive") {
                        return null; // Don't render this menu
                      }

                      // For admin, show all menus and submenus (ignore visibility status)
                      if (
                        (dbAppTypeDocuments.apptype === "lite" &&
                          user?.role === "superAdmin") ||
                        (dbAppTypeDocuments.apptype === "pro" &&
                          (user?.role === "superAdmin" ||
                            user?.role === "admin"))
                      ) {
                        return (
                          <React.Fragment key={`menu-${index}`}>
                            {/* Main Menu */}
                            <div className="profile-two__admin-menu-item">
                              <div className="profile-two__admin-menu-content">
                                <Link
                                  to={menu.pageUrl}
                                  style={{ minWidth: "100%" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center business-three-profile-content">
                                    <div className="d-flex align-items-center business-three-profile-icon">
                                      <div className="profile-two__admin-menu-icon">
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: menu.iconName,
                                          }}
                                        />
                                      </div>
                                      &nbsp; &nbsp;
                                      <div className="profile-two__admin-menu-text">
                                        <h4 className="profile-two__admin-menu-name">
                                          {menu.menuName}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="profile-two__admin-menu-arrow">
                                      <div className="d-flex align-items-center">
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            color: "var(--logo-primary-color)",
                                          }}
                                        >
                                          Hide
                                        </p>
                                        &nbsp;
                                        <DarkModeToggle
                                          onChange={() =>
                                            handleVisibleInProfilePage(index)
                                          } // Pass the correct indices for the main menu
                                          checked={
                                            menu.visibilityInProfilePage ||
                                            false
                                          }
                                          size={30}
                                        />
                                        &nbsp;
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            color: "var(--logo-primary-color)",
                                          }}
                                        >
                                          Unhide
                                        </p>
                                        <span
                                          className="material-symbols-outlined"
                                          style={{
                                            fontSize: "18px",
                                            color: "black",
                                          }}
                                        >
                                          chevron_right
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>

                            {/* Submenus */}
                            {menu.subMenu &&
                              menu.subMenu.map((subMenuItem, subIndex) => {
                                // Skip submenu if subMenuStatus is inactive
                                if (subMenuItem.subMenuStatus === "inactive") {
                                  return null; // Don't render this submenu
                                }

                                return (
                                  <div
                                    className="profile-two__admin-menu-item"
                                    key={`submenu-${index}-${subIndex}`}
                                  >
                                    <div className="profile-two__admin-menu-content">
                                      <Link
                                        to={subMenuItem.subMenuPageUrl}
                                        style={{ minWidth: "100%" }}
                                      >
                                        <div className="d-flex justify-content-between align-items-center business-three-profile-content">
                                          <div className="d-flex align-items-center business-three-profile-icon">
                                            <div className="profile-two__admin-menu-icon">
                                              <span
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    subMenuItem.subMenuIcon,
                                                }}
                                              />
                                            </div>
                                            &nbsp; &nbsp;
                                            <div className="profile-two__admin-menu-text">
                                              <h4 className="profile-two__admin-menu-name">
                                                {subMenuItem.subMenuName}
                                              </h4>
                                            </div>{" "}
                                          </div>
                                          <div className="d-flex align-items-center">
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                color:
                                                  "var(--logo-primary-color)",
                                              }}
                                            >
                                              Hide
                                            </p>
                                            &nbsp;
                                            <DarkModeToggle
                                              onChange={() =>
                                                handleVisibleInProfilePage(
                                                  index,
                                                  subIndex
                                                )
                                              } // Pass indices for submenu
                                              checked={
                                                subMenuItem.visibilityInProfilePage ||
                                                false
                                              }
                                              size={30}
                                            />
                                            &nbsp;
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                color:
                                                  "var(--logo-primary-color)",
                                              }}
                                            >
                                              Unhide
                                            </p>
                                            <span
                                              className="material-symbols-outlined"
                                              style={{
                                                fontSize: "18px",
                                                color: "black",
                                              }}
                                            >
                                              chevron_right
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                );
                              })}
                          </React.Fragment>
                        );
                      }

                      // For other users, show only menus and submenus with visibilityInProfilePage = true
                      const showMainMenu = menu.visibilityInProfilePage;
                      const subMenusToShow =
                        menu.subMenu &&
                        menu.subMenu.filter(
                          (subMenuItem) =>
                            subMenuItem.visibilityInProfilePage &&
                            subMenuItem.subMenuStatus !== "inactive"
                        );

                      if (
                        !showMainMenu &&
                        (!subMenusToShow || subMenusToShow.length === 0)
                      ) {
                        return null; // Skip this menu entirely if nothing to show
                      }

                      return (
                        <React.Fragment key={`menu-${index}`}>
                          {/* Main Menu */}
                          {showMainMenu && (
                            <div className="profile-two__admin-menu-item">
                              <div className="profile-two__admin-menu-content">
                                <Link
                                  to={menu.pageUrl}
                                  style={{ minWidth: "100%" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center business-three-profile-content">
                                    <div className="d-flex align-items-center business-three-profile-icon">
                                      <div className="profile-two__admin-menu-icon">
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: menu.iconName,
                                          }}
                                          style={{ display: "flex" }}
                                        />
                                      </div>
                                      &nbsp; &nbsp;
                                      <div className="profile-two__admin-menu-text">
                                        <h4 className="profile-two__admin-menu-name">
                                          {menu.menuName}
                                        </h4>
                                      </div>
                                    </div>
                                    <span
                                      className="material-symbols-outlined"
                                      style={{
                                        fontSize: "18px",
                                        color: "black",
                                      }}
                                    >
                                      chevron_right
                                    </span>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          )}

                          {/* Submenus */}
                          {subMenusToShow &&
                            subMenusToShow.map((subMenuItem, subIndex) => (
                              <div
                                className="profile-two__admin-menu-item"
                                key={`submenu-${index}-${subIndex}`}
                              >
                                <div className="profile-two__admin-menu-content">
                                  <Link
                                    to={subMenuItem.subMenuPageUrl}
                                    style={{ minWidth: "100%" }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center business-three-profile-content">
                                      <div className="d-flex align-items-center business-three-profile-icon">
                                        <div className="profile-two__admin-menu-icon">
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: subMenuItem.subMenuIcon,
                                            }}
                                          />
                                        </div>
                                        &nbsp; &nbsp;
                                        <div className="profile-two__admin-menu-text">
                                          <h4 className="profile-two__admin-menu-name">
                                            {subMenuItem.subMenuName}
                                          </h4>
                                        </div>
                                      </div>
                                      <span
                                        className="material-symbols-outlined"
                                        style={{
                                          fontSize: "18px",
                                          color: "black",
                                        }}
                                      >
                                        chevron_right
                                      </span>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            ))}
                        </React.Fragment>
                      );
                    })}
                </div>{" "}
              </div>
            </>
            {/* DYNAMIC MENUS END */}

            {/* START CODE FOR SELLERS */}
            {user &&
              user &&
              organisationDetails &&
              organisationDetails.isMultiVendor && (
                <section className="profile-two__default-section">
                  <h3 className="profile-two__section-title">
                    Sell Online with&nbsp;
                    {organisationDetails && organisationDetails.full_name}
                  </h3>
                  <div className="profile-two__admin-menu-grid">
                    <div className="profile-two__admin-menu-item">
                      <Link
                        to={`/vendor-registration/${user.phoneNumber}`}
                        className="profile-two__admin-menu-content"
                      >
                        <div className="profile-two__admin-menu-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="currentColor"
                          >
                            <path d="M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z" />
                          </svg>
                        </div>
                        <div className="profile-two__admin-menu-text">
                          <h4 className="profile-two__admin-menu-name">
                            Become A Seller
                          </h4>
                          <p className="profile-two__admin-menu-description">
                            Become a seller
                          </p>
                        </div>
                        <div className="profile-two__admin-menu-arrow">
                          <HiChevronRight />
                        </div>
                      </Link>
                    </div>
                    <div className="profile-two__admin-menu-item">
                      <Link
                        to={`/manage-account/${user.phoneNumber}`}
                        className="profile-two__admin-menu-content"
                      >
                        <div className="profile-two__admin-menu-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="currentColor"
                          >
                            <path d="M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z" />
                          </svg>
                        </div>
                        <div className="profile-two__admin-menu-text">
                          <h4 className="profile-two__admin-menu-name">
                            Manage Seller Accounts
                          </h4>
                          <p className="profile-two__admin-menu-description">
                            Manage Seller Accounts
                          </p>
                        </div>
                        <div className="profile-two__admin-menu-arrow">
                          <HiChevronRight />
                        </div>
                      </Link>
                    </div>
                  </div>
                </section>
              )}
            {/* END CODE FOR SELLERS */}

            {user && user && (
              <div className="profile-two__logout-container">
                <button
                  className="profile-two__logout-button"
                  onClick={showLogoutPopup}
                  disabled={isPending}
                >
                  <HiLogout className="profile-two__logout-icon" />
                  <span>{isPending ? "Logging out..." : "Logout"}</span>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* EDIT USER DETAILS START */}
        {showEditPopup && (
          <>
            <div
              className={`business-three-profile-edit-overlay ${
                showEditPopup
                  ? "business-three-profile-overlay-open"
                  : "business-three-profile-overlay-close"
              }`}
            />
            <div
              className={`business-three-profile-edit-popup ${
                showEditPopup
                  ? "business-three-profile-open"
                  : "business-three-profile-close"
              }`}
            >
              <div className="business-three-profile-edit-popup-content">
                <div className="business-three-profile-edit-popup-header">
                  <h2>Edit Details</h2>
                  <span
                    className="business-three-profile-edit-popup-close"
                    onClick={handleCancelClick}
                  >
                    &times;
                  </span>
                </div>
                <div className="business-three-profile-edit-popup-body">
                  <input
                    type="text"
                    name="fullName"
                    value={userDetails.fullName}
                    onChange={handleInputChange}
                    placeholder="Full Name"
                  />
                  <input
                    type="textarea"
                    name="address"
                    value={userDetails.address}
                    onChange={handleInputChange}
                    placeholder="Address"
                  />
                  <input
                    type="textarea"
                    name="city"
                    value={userDetails.city}
                    onChange={handleInputChange}
                    placeholder="City"
                  />
                  <input
                    type="email"
                    name="email"
                    value={userDetails.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                  />
                </div>
                <div className="business-three-profile-edit-popup-footer">
                  {/* <Link to={`/user-detail/${user.uid}`}>
                    <button className="btn_fill">More Details</button>
                  </Link> */}

                  <button
                    onClick={handleConfirmClick}
                    disabled={confirmButtonDisabled}
                    className="btn_fill"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {/* END EDIT USER DETAILS  */}

        {/* start Image Change Popup */}
        {showImagePopup && (
          <>
            <div
              className={`business-three-profile-edit-overlay ${
                showImagePopup
                  ? "business-three-profile-overlay-open"
                  : "business-three-profile-overlay-close"
              }`}
            />
            <div
              className={`business-three-profile-edit-popup ${
                showImagePopup
                  ? "business-three-profile-open"
                  : "business-three-profile-close"
              }`}
            >
              <div className="business-three-profile-edit-popup-header">
                <h2>Change Picture</h2>
                {!imgUploading && (
                  <span
                    className="business-three-profile-edit-popup-close"
                    onClick={handleCancelImgClick}
                  >
                    &times;
                  </span>
                )}
              </div>
              <div className="row">
                <div className="business-three-profile-popup-body col-12 col-md-4">
                  <div className="row">
                    <div className="business-three-profile-image-preview col-6 col-md-12">
                      <img
                        src={imagePreview || (user && user.photoURL)}
                        alt="Preview"
                      />
                      {!imgUploading && (
                        <div style={{ cursor: "pointer" }}>
                          <span
                            className="material-symbols-outlined business-three-profile-delete-icon"
                            onClick={handleRemoveImage}
                          >
                            delete
                          </span>
                        </div>
                      )}
                    </div>
                    {imgUploading ? (
                      <div className="d-flex align-items-center justify-content-center col-6 col-md-12">
                        <PGLoaders />
                      </div>
                    ) : (
                      <div className="business-three-profile-button-group col-6 col-md-12">
                        {/* start file and camera for mobile */}
                        <div className="d-flex justify-content-between business-three-profile-icon-group">
                          {!imgUploading && (
                            <div
                              style={{
                                cursor: "pointer",
                                backgroundColor: "var(--grey-light)",
                                padding: "5px",
                                borderRadius: "6px",
                              }}
                              className="d-flex align-items-center"
                            >
                              <input
                                type="file"
                                accept="image/*"
                                id="file-input"
                                capture="environment" // Opens camera by default on mobile devices
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                              />
                              <span
                                className="material-symbols-outlined business-three-profile-delete-icon"
                                onClick={() =>
                                  document.getElementById("file-input").click()
                                }
                              >
                                photo_camera
                              </span>
                            </div>
                          )}

                          {!imgUploading && (
                            <div
                              style={{
                                cursor: "pointer",
                                backgroundColor: "var(--grey-light)",
                                padding: "5px",
                                borderRadius: "6px",
                              }}
                              className="d-flex align-items-center"
                            >
                              <input
                                type="file"
                                accept="image/*"
                                id="file-input"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                              />
                              <span
                                className="material-symbols-outlined business-three-profile-delete-icon"
                                onClick={() =>
                                  document.getElementById("file-input").click()
                                }
                              >
                                folder_open
                              </span>
                            </div>
                          )}
                        </div>
                        {/* end file and camera for mobile */}

                        {/* start file for pc */}
                        <input
                          type="file"
                          accept="image/*"
                          id="file-input"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <button
                          onClick={() =>
                            document.getElementById("file-input").click()
                          }
                          className="btn_fill pc_profile_browse_btn"
                        >
                          Browse
                        </button>
                        {/* end file for pc */}
                        {imagePreview && (
                          <button
                            onClick={handleConfirmImgClick}
                            className="btn_fill"
                          >
                            Confirm
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="business-three-profile-popup-footer col-12 col-md-8">
                  <div className="business-three-profile-line-container">
                    <div className="business-three-profile-line"></div>
                    <div className="business-three-profile-or-text">or</div>
                    <div className="business-three-profile-line"></div>
                  </div>
                  <div className="business-three-profile-dummy-images">
                    {dummyImages.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Dummy ${index + 1}`}
                        onClick={() => handleDummyImageClick(img)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* END CHANGE PROFILE IMAGE CODE  */}
      </div>
    </>
  );
};

export default ProfileTwo;
